import { Badge, Space, Typography } from "antd";
import { Button } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { formatMoney } from "../../../utils/util";
import { docLinkRender } from "../../../components/table/DocLink";
import {
  EditableRow,
  EditableCell,
} from "../../../components/table/TableEditAble";

/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

const optionTypeSup = [
  { value: "IG", label: "Ingredients" },
  { value: "RM", label: "Raw Material" },
  { value: "PK", label: "Packaging" },
  { value: "API", label: "Oversea" },
  { value: "GR", label: "General" },
];

export const purchaseTypeOptions = [
  { value: "QTY", label: "ตามจำนวน" },
  { value: "LOT", label: "เป็น MOQ" },
];

const Link = Typography.Link;

export const accessColumn = ({ handleEdit, handleDelete, handleView }) => [
  {
    title: "รหัสผู้ขาย",
    key: "supcode",
    dataIndex: "supcode",
    align: "left",
    width: 110,
    sorter: (a, b) => (a?.supcode || "").localeCompare(b?.supcode || ""),
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: (text, record) => (
      <Link onClick={() => handleEdit(record)}>{text}</Link>
    ),
  },
  {
    title: "ชื่อผู้ขาย",
    dataIndex: "supname",
    key: "supname",
    width: "20%",
    sorter: (a, b) => (a?.supname || "").localeCompare(b?.supname || ""),
  },
  {
    title: "ประเภทผู้ขาย",
    dataIndex: "type",
    key: "type",
    align: "left",
    width: 120,
    sorter: (a, b) => (a?.type || "").localeCompare(b?.type || ""),
    render: (v, record) => {
      const found = optionTypeSup.find((opt) => opt.value === v);
      return (
        <Typography.Text className="text-select hover:underline underline-offset-1">
          {found ? found.label : v}
        </Typography.Text>
      );
    },
  },
  {
    title: "ที่อยู่",
    dataIndex: "idno",
    key: "idno",
    sorter: (a, b) => (a?.idno || "").localeCompare(b?.idno || ""),
    render: (_, head) => (
      <Typography.Text>
        {head.idno && `${head.idno}`}
        {head.road && ` ${head.road}`}
        {head.subdistrict && ` ${head.subdistrict}`}
        {head.district && ` ${head.district}`}
        {head.province && ` ${head.province}`}
        {head.zipcode && ` ${head.zipcode}`}
        {head.tel && ` ${head.tel}`}
      </Typography.Text>
    ),
  },
  {
    title: "ประเทศ",
    dataIndex: "country",
    key: "country",
    sorter: (a, b) => (a?.country || "").localeCompare(b?.country || ""),
    width: 140,
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: 120,
    sorter: (a, b) =>
      (a?.active_status || "").localeCompare(b?.active_status || ""),
    /* รองรับข้อมูลเก่าที่เคยเก็บเป็น Y/N และแถวที่ยังไม่เคยตั้งค่า */
    render: (data) => {
      const isOff = data === "ปิดการใช้งาน" || data === "N";
      return (
        <div>
          {isOff ? (
            <Badge status="error" text="ปิดการใช้งาน" />
          ) : (
            <Badge status="success" text="เปิดการใช้งาน" />
          )}
        </div>
      );
    },
  },
  // {
  //   title: "วันที่สร้าง",
  //   dataIndex: "created_date",
  //   key: "created_date",
  //   width: 120,
  //   sorter: (a, b) =>
  //     (a?.created_date || "").localeCompare(b?.created_date || ""),
  //   render: (v) => dayjs(v).format("DD/MM/YYYY"),
  // },
  {
    title: "Action",
    key: "operation",
    width: "100px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];

export const columnsParametersEditable = (
  handleSave,
  { handleRemove, modalSelect, readOnly = false }
) => {
  const col = ProductColumn({ handleRemove, readOnly });
  return col.map((col, ind) => {
    if (readOnly || !col.editable) return col;

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        const editable =
          typeof col.editable === "function"
            ? col.editable(record)
            : col.editable;
        return {
          record,
          editable,
          dataIndex: col.dataIndex,
          title: col.title,
          required: !!col?.required,
          type: col?.type || "input",
          optionsItems: col?.optionsItems,
          modalSelect,
          handleSave,
        };
      },
    };
  });
};

export const ProductColumn = ({ handleRemove, readOnly = false }) => [
  {
    title: "ลำดับ",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: "5%",
    render: (im, rc, index) => <>{index + 1}</>,
  },
  {
    title: "รหัสสินค้า",
    key: "stcode",
    dataIndex: "stcode",
    width: "12px",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
  },
  {
    title: "ชนิดสินค้า",
    dataIndex: "typename",
    key: "typename",
    align: "center",
    width: "12px",
  },
  {
    title: "รูปแบบการซื้อ",
    dataIndex: "purchase_type",
    key: "purchase_type",
    align: "center",
    width: 140,
    editable: true,
    required: true,
    type: "select",
    optionsItems: purchaseTypeOptions,
    render: (v) => {
      const found = purchaseTypeOptions.find((o) => o.value === v);
      return found ? found.label : "ตามจำนวน";
    },
  },
  {
    title: "ขั้นต่ำ (QTY)",
    dataIndex: "min_qty",
    key: "min_qty",
    align: "right",
    className: "!pe-3",
    width: 120,
    editable: (record) => record?.purchase_type !== "LOT",
    type: "number",
    render: (v, record) =>
      record?.purchase_type === "LOT"
        ? "-"
        : v
        ? formatMoney(Number(v), 2, 2)
        : "-",
  },
  {
    title: "MOQ",
    dataIndex: "lot_summary",
    key: "lot_summary",
    align: "center",
    width: 170,
    editable: (record) => record?.purchase_type === "LOT",
    type: "modal-select",
    render: (v, record) =>
      record?.purchase_type === "LOT" ? v || "ระบุ MOQ" : "-",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    width: "10%",
    align: "right",
    className: "!pe-3",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.price || 0), 2, 2)}</>,
  },
  {
    title: "ราคา ณ วันที่",
    dataIndex: "price_date",
    key: "price_date",
    align: "center",
    width: 140,
    sorter: (a, b) => (a?.price_date || "").localeCompare(b?.price_date || ""),
    editable: true,
    type: "date", // เพิ่ม type
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : ""),
  },
  ...(readOnly
    ? []
    : [
        {
          title: "ตัวเลือก",
          align: "center",
          key: "operation",
          dataIndex: "operation",
          render: (_, record, idx) => handleRemove(record),
          width: "4%",
          fixed: "right",
        },
      ]),
];

export const supplier = {
  id: null,
  supcode: null,
  supname: null,
  prename: null,
  idno: null,
  road: null,
  subdistrict: null,
  district: null,
  province: null,
  zipcode: null,
  country: null,
  delidno: null,
  delroad: null,
  delsubdistrict: null,
  deldistrict: null,
  delprovince: null,
  delzipcode: null,
  delcountry: null,
  tel: null,
  fax: null,
  taxnumber: null,
  payment: null,
  email: null,
  active_status: "เปิดการใช้งาน",
};
